
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetServerSideProps } from "next"
import Head from "next/head"
import { ParsedUrlQuery } from "querystring"

import getCreator from "@/graphql/requests/getCreator"
import getCreatorProducts from "@/graphql/requests/getCreatorProducts"
import SEO from "@/meta/SEO"
import Default from "@/templates/Default"
import Creator from "@/ts/Creator"
import { FansiKind } from "@/ts/Global"
import Product from "@/ts/Product"
import CreatorView from "@/views/creator"

function CreatorPage(props: CreatorPageProps) {
  const { staticCreator, staticProducts } = props

  return (
    <>
      <Head>
        <title>Twórca - {staticCreator.creators[0].nickname} | fansi.pl</title>
        <SEO description={staticCreator.creators[0].description} />
      </Head>
      <CreatorView
        creator={staticCreator.creators[0]}
        products={staticProducts}
      />
    </>
  )
}

 const _getServerSideProps: GetServerSideProps = async ({ params }) => {
  const { slug } = params as Params
  const staticCreator = await getCreator(slug)
  const creator = staticCreator.creators?.[0]

  if (!creator) return { notFound: true }

  const staticProducts = await getCreatorProducts(creator.id)

  return { props: { staticCreator, staticProducts, slug } }
}

CreatorPage.Layout = Default

interface CreatorPageProps {
  staticCreator: {
    creators: Creator[]
  }
  staticProducts: Record<FansiKind, Product[]>
  slug: string
}
interface Params extends ParsedUrlQuery {
  slug: string
}

export default CreatorPage


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/creators/[slug]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  